import { useWindowDimensions } from 'react-native'
import { useNotificationConfig } from './useNotificationConfig'
import { useReducer, useRef, useState } from 'react'
import { getTopOffset, mergeConfigs } from '../utils/pickers'
import { queueReducer } from '../utils/queueReducer'

export const useNotificationsStates = () => {
  const panHandlerRef = useRef(null)
  const longPressHandlerRef = useRef(null)
  const { height: windowHeight, width: windowWidth } = useWindowDimensions()
  const globalConfig = useNotificationConfig()
  const [notificationsQueue, dispatch] = useReducer(queueReducer, [])
  const [notificationHeight, setNotificationHeight] = useState(0)

  const isPortaitMode = windowHeight > windowWidth
  const notificationEvent = notificationsQueue[0]
  const config = mergeConfigs(globalConfig, notificationEvent)

  const topOffset = getTopOffset({
    globalConfig: config,
    notificationHeight,
    isPortaitMode,
    windowHeight,
  })

  return {
    config,
    dispatch,
    topOffset,
    panHandlerRef,
    notificationEvent,
    notificationsQueue,
    longPressHandlerRef,
    setNotificationHeight,
    isPortaitMode,
  }
}

export type NotificationState = ReturnType<typeof useNotificationsStates>
